import React, { useState, useEffect } from 'react';
import Styles from './taskbar.module.css';
import windowLogo from '../images/windows.png';
import Volume from '../images/Volume.png';
import SecurityError from '../images/SecurityError.png';

export default function Taskbar({ windows, onRestore, onToggleStart }) {
  const [currentTime, setCurrentTime] = useState('');

  // Update time every second
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      let hours = now.getHours();
      const minutes = now.getMinutes();
      const ampm = hours >= 12 ? 'PM' : 'AM';

      // Convert to 12-hour format
      hours = hours % 12;
      hours = hours ? hours : 12; // 0 should be 12

      // Add leading zero to minutes
      const minutesStr = minutes < 10 ? '0' + minutes : minutes;

      setCurrentTime(`${hours}:${minutesStr} ${ampm}`);
    };

    // Set initial time
    updateTime();

    // Update every second
    const interval = setInterval(updateTime, 1000);

    // Cleanup on unmount
    return () => clearInterval(interval);
  }, []);

  return (
    <section className={Styles.taskbar}>
      <div className={`${Styles.start} taskbar-start-button`} onClick={onToggleStart}>
        <div
          className={Styles.logo}
          style={{ backgroundImage: `url(${windowLogo})` }}
        ></div>
        <p>start</p>
      </div>

      <div className={Styles.tasks}>
        {windows.map(win => (
          <div
            key={win.id}
            className={win.minimized ? `${Styles.process} ${Styles.minimized}` : `${Styles.process} ${Styles.open}`}
            onClick={() => onRestore(win.id)}
          >
            <div
              className={Styles.image}
              style={{ backgroundImage: `url(${win.icon})` }}
            ></div>
            <div className={Styles.title}>{win.title}</div>
          </div>
        ))}
      </div>

      {/* Real-time clock */}
      <div className={Styles.bench}>
        <div className={Styles.language}>EN</div>
        <div className={Styles.benchIcon} style={{backgroundImage: `url(${Volume})`}} ></div>
        <div className={Styles.benchIcon} style={{backgroundImage: `url(${SecurityError})`}} ></div>
        {currentTime}
      </div>
    </section>
  );
}